import React from 'react';
import SmartDialog from "../../../../components/SmartDialog";
import {Field, Form, Formik} from 'formik'
import {Button, Label} from "reactstrap";
import FormInput from "../../../../components/FormInput";
import TTLProxy from "../../../../common/TTLAsyncProxy";
import {USSDEndpoints} from "../../../../common/ProxyEndpoints";
import HTML from '../../../../common/HtmlHelpers';
import Utils from "../../../../common/Utils";
import MDProgress from 'react-md-progress-bar';
import PropTypes from 'prop-types';
import {BindingValidationSchema, DefaultBindingProduct} from "./USSDServicesCommon";

class EditBindingDialog extends React.Component {

    static propTypes = {
        onEdit: PropTypes.func
    };

    constructor(props){
        super(props);
        this.state = {
            binding: null
        };

        this.proxy = TTLProxy.getInstance();
    }

    show(binding){

        this.setState({
            binding
        }, () => {
            this._dlg.show();
        });

    }

    async onSubmit(values){

        const { binding } = this.state;

        try {

            const res = await this.proxy.processRequest(USSDEndpoints.updateServiceBinding(binding.id, {
                product: values.isDefaultProduct === true ? DefaultBindingProduct : values.product,
                cost: values.cost
            }));

            if(res.ok){

                //  updated successfully
                HTML.toastSuccess('Updated successfully');

                if(this.props.onEdit)
                    this.props.onEdit();

                this._dlg.hide();
            }

        }
        catch (e) {
            HTML.toastError(Utils.getResponseError(e));
        }


    }

    render(){

        const { binding } = this.state;
        return <SmartDialog title="Edit Price Definition" ref={r => this._dlg = r}>

            <Formik initialValues={{
                        isDefaultProduct: binding ? binding.product === DefaultBindingProduct :  false,
                        product: binding ? binding.product : '',
                        cost: binding ? binding.cost : 1
                    }}
                    enableReinitialize
                    ref={r => this._form = r}
                    validationSchema={BindingValidationSchema}
                    onSubmit={async (values,{ setSubmitting }) =>{

                try{
                    await this.onSubmit(values);
                }
                catch (e) {

                    //  Failed submitting

                }
                finally {
                    setSubmitting(false);
                }

            }}>
                {({ isValid , isSubmitting , values }) => (<Form>


                    <div className="clearfix">

                        <div className="pull-left">
                            <Label for={"product"}><i className="fa fa-book"/> Product</Label>
                        </div>

                        <div className="pull-right">
                            <Field name="isDefaultProduct">
                                {({ field , form: { setFieldValue }}) =>{
                                    return <label><input type="checkbox" checked={field.value} onChange={evt => setFieldValue("isDefaultProduct",evt.target.checked)}/> Is Default Product</label>
                                }}
                            </Field>
                        </div>

                    </div>

                    <FormInput name="product"
                               type="text"
                               placeholder={"Enter product name"}
                               required={true}
                               disabled={values.isDefaultProduct}/>

                    <FormInput name="cost"
                               title={<span><i className="fa fa-money"/> Cost</span>}
                               type="number"
                               placeholder={"Enter cost of product in region"}
                               required={true}/>

                               <hr/>

                    {isSubmitting && <MDProgress show overlay/>}

                    <Button color="green" disabled={!isValid || isSubmitting} block><i className="fa fa-edit"/> Save Changes</Button>


                </Form>)}
            </Formik>

        </SmartDialog>
    }

}

export default EditBindingDialog;


// WEBPACK FOOTER //
// ./src/views/Extras/Services/USSDServices/EditBindingDialog.js